import script from "./message-timestamp.vue?vue&type=script&setup=true&lang=ts"
export * from "./message-timestamp.vue?vue&type=script&setup=true&lang=ts"

import "./message-timestamp.vue?vue&type=style&index=0&id=673faa2b&lang=scss&scoped=true"

import exportComponent from "/Users/ls/Documents/维思英才/webchat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-673faa2b"]])

export default __exports__